import { all, put,call, takeLatest } from 'redux-saga/effects';
import * as PorteEmpreendimento from '~/services/PorteEmpreendimento'
import  * as actionType from './actionType';
import * as actions from './action';
import { getErros } from '~/store/modules/errors/action';

function* loadPorteEmpreendimentosWorker() {
  try {
    const response = yield call(PorteEmpreendimento.load);
    yield put(actions.getPorteEmpreendimentos(response));
    yield put(actions.getErros({}));
    yield put(getErros({}));
  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}


function* showPorteEmpreendimentoWorker({porte_empreendimento}) {
  try {
    const response = yield call(PorteEmpreendimento.show, porte_empreendimento);
    yield put(actions.getPorteEmpreendimento(response));
    yield put(actions.getErros({}));
    yield put(getErros({}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* updatePorteEmpreendimentoWorker({ potencial_poluidor, id}) {
  try {
    const response = yield call(PorteEmpreendimento.update, id, potencial_poluidor);
    yield put(actions.getPorteEmpreendimento(response));
    yield put(actions.getErros({update:true}));
    yield put(getErros({update:true}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* storePorteEmpreendimentoWorker({potencial_poluidor}) {
  try {
    const response = yield call(PorteEmpreendimento.store, potencial_poluidor);
    yield put(actions.getPorteEmpreendimento(response));
    yield put(actions.getErros({save:true}));
    yield put(getErros({save:true}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* removerPorteEmpreendimentoWorker({id}) {
  try {
    yield call(PorteEmpreendimento.destroy, id);
    yield put(actions.getErros({}));
    yield put(getErros({}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* watcherPorteEmpreendimento() {
  yield takeLatest(actionType.LOAD_PORTE_EMPREENDIEMENTOS, loadPorteEmpreendimentosWorker);
  yield takeLatest(actionType.STORE_PPORTE_EMPREENDIEMENTO, storePorteEmpreendimentoWorker);
  yield takeLatest(actionType.SHOW_PORTE_EMPREENDIEMENTO, showPorteEmpreendimentoWorker);
  yield takeLatest(actionType.UPDATE_PORTE_EMPREENDIEMENTO, updatePorteEmpreendimentoWorker);
  yield takeLatest(actionType.REMOVER_PORTE_EMPREENDIEMENTO, removerPorteEmpreendimentoWorker);
}

export default function* saga() {
  yield all([watcherPorteEmpreendimento()]);
}
